import React, { useEffect } from 'react';
import { Container } from './styles';
import {
  CustomersState,
  ECreditRenewStatus,
  ICustomer
} from '../../../../store/ducks/customers/types';
import { useDispatch } from 'react-redux';
import { loadCustomerFromId } from '../../../../store/ducks/customers/actions';
import Skeleton from 'react-loading-skeleton';

interface ICreditRequestedMessageModalProps {
  selectedCustomer: ICustomer;
  customersState: CustomersState;
}

const CreditRequestedMessageModalContent: React.FC<
  ICreditRequestedMessageModalProps
> = ({ selectedCustomer, customersState }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !customersState.loadingCustomerById &&
      (selectedCustomer.lastUpdateTime === undefined ||
        new Date().getTime() - selectedCustomer.lastUpdateTime > 1800000)
    ) {
      // atualiza o customer para obter o status da solicitação de renovação de LC a cada 30 minutos
      dispatch(loadCustomerFromId(selectedCustomer.customerId));
    }
  });

  return (
    <Container>
      {customersState.loadingCustomerById && (
        <div style={{ margin: '0.5rem 0 1.5rem 0' }}>
          <Skeleton count={4} />
        </div>
      )}

      {!customersState.loadingCustomerById && (
        <>
          {selectedCustomer.creditRenewRequestStatus &&
            selectedCustomer.creditRenewRequestStatus ===
              ECreditRenewStatus.IN_PROCESS && (
              <>
                <h4 className="title">
                  Renovação de limite de crédito já solicitada
                </h4>
                <p className="message">
                  Sua solicitação{' '}
                  <strong>{selectedCustomer.creditRenewCode}</strong> para
                  renovação de limite de crédito está em andamento e será
                  analisada em até 6 horas.
                  <br></br>
                  Em caso de dúvida, entre em contato com seu vendedor.
                </p>
              </>
            )}

          {(!selectedCustomer.creditRenewRequestStatus ||
            (selectedCustomer.creditRenewRequestStatus &&
              selectedCustomer.creditRenewRequestStatus ===
                ECreditRenewStatus.CANCELED)) && (
            <>
              <h4 className="title">
                Renovação de limite de crédito rejeitada
              </h4>
              <p className="message">
                Sua solicitação{' '}
                <strong>{selectedCustomer.creditRenewCode}</strong> para
                renovação de limite de crédito foi rejeitada.
                <br></br>
                Para mais informações, entre em contato com seu vendedor.
              </p>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default CreditRequestedMessageModalContent;
